import { GlobalSendRecentTransactionsRequest, GlobalSendRecentTransaction } from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';
import { useDataFetchIndicator } from '..';

import vopayApi from '@/services/api.config';

const initHook = vopayApi.withApiHook(({ api }) => {
  return function useFetchTransactions() {
    const source = axios.CancelToken.source();
    const [transactions, setTransactions] = useState<GlobalSendRecentTransaction[]>([]);
    const [, setDataFetchingInfo] = useDataFetchIndicator();

    const fetchTransactions = async (requestParams: GlobalSendRecentTransactionsRequest) => {
      setDataFetchingInfo(true);

      const res = await api.fetchRecentGlobalSendTransactions(
        {
          ...requestParams,
        },
        source,
      );

      setTransactions(res.Transactions);
      setDataFetchingInfo(false);

      return res;
    };

    useEffect(() => {
      return () => {
        source.cancel();
      };
    }, []);

    return {
      transactions,
      fetchTransactions,
    };
  };
});

export default initHook({});
